import { render, staticRenderFns } from "./FilmTranslation.vue?vue&type=template&id=b0b09f48"
import script from "./FilmTranslation.vue?vue&type=script&lang=js"
export * from "./FilmTranslation.vue?vue&type=script&lang=js"
import style0 from "./FilmTranslation.vue?vue&type=style&index=0&id=b0b09f48&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports